import TableRowPerAction from "../../../../Components/Common/TableRowPerAction";
import TableData from "../../../../Components/Common/TableData";
import TableRow from "../../../../Components/Common/TableRow";
import { convertToLocalDateTime } from "../../../../utils/convertToLocalDateTime";
import { useAlert } from "../../../../Context/AlertContext";
import useSWRMutation from "swr/mutation";
import { sendDeleteRequestAuth } from "../../../../Api/swrConfig";
import { toast } from "react-toastify";
import useToastError from "../../../../hooks/useErrorToast";
import { RoleApiUrls } from "../../../../Api/Auth/ApiUrls";

function RoleRow({ row, mutate, onEditClick }) {
  const { showAlert, setIsLoading } = useAlert();
  const { showErrorToast } = useToastError();

  const { trigger: deleteTrigger } = useSWRMutation(
    RoleApiUrls.delete(row._id),
    sendDeleteRequestAuth,
    {
      onSuccess: () => {
        setIsLoading(false);
        toast.success("Success");
        mutate();
      },
      // If error occurred - make delete false
      onError: (error) => {
        setIsLoading(false);
        showErrorToast(error);
      },
    }
  );

  // Define the function to call delete mutation with Alert Dialog
  const handleDelete = () => {
    showAlert(
      `Are you sure you want to delete the role "${row.roleName}"?`,
      async () => {
        setIsLoading(true);
        await deleteTrigger(row.roleId);
      }
    );
  };
  return (
    <>
      <TableRow key={row.roleId}>
        <TableData>{row.roleId}</TableData>
        <TableData>{row.roleName}</TableData>
        <TableData>{row.description}</TableData>
        <TableData>{convertToLocalDateTime(row.createdAt)}</TableData>

        <TableRowPerAction
          onEdit={
            [0, 1, 2, 6].includes(row.roleId) ? null : () => onEditClick(row)
          }
          onDelete={[0, 1, 2, 6].includes(row.roleId) ? null : handleDelete}
        />
      </TableRow>
    </>
  );
}

export default RoleRow;
